import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ReCAPTCHA from 'react-google-recaptcha';
import { CircularProgress, Divider, FormHelperText } from '@mui/material';
import { Button } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { getData, postData } from '../../services/fetch-service';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import dayjs from 'dayjs';
import { setPaymentResponse } from '../store/dataslice';
import PayseraPayment from '../PayseraPayment';
import { FaEuroSign } from 'react-icons/fa';
import { LoadingOverlay, Loader } from '@mantine/core';
import Swal from 'sweetalert2';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

const Policia_PaymentFields = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);
    const [updateLoader, setUpdateLoader] = useState(false);

    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);
    const [kerkoLoading, setKerkoLoading] = useState(false);
    const [NumriSerik, setNumriSerik] = useState();
    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);
    const [InstitucioniServiceData, setInstitucioniServiceData] = useState(null);
    const [Loan, setLoan] = useState(false);

    // const fetchInstitucioniServiceData = async (token) => {
    //     try {
    //         const response = await getData(`Pagesat/GetInstitucionServiceData?llojipagesesID=137&serialNumber=${NumriSerik}&token=${token}`);
    //         setInstitucioniServiceData(response.data.respond);
    //         setKerkoLoading(false);
    //     } catch (error) {
    //         setKerkoLoading(false);
    //         setInstitucioniServiceData(null);
    //         Swal.fire({
    //             icon: 'error',
    //             title: 'Gabim',
    //             text: 'Pagesa me këtë shifër të Uniref nuk është gjetur!'
    //         });
    //     }
    // };

    const fetchInstitucioniServiceData = async (token) => {
        try {
            const response = await postData('Pagesat/GetInstitucionServiceData', {
                llojipagesesID: 137,
                serialNumber: NumriSerik,
                token: token
            });
            if (response) {
                setInstitucioniServiceData(response.data.respond);
                setKerkoLoading(false);
            }
        } catch (error) {
            setKerkoLoading(false);
            setInstitucioniServiceData(null);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: 'Pagesa me këtë shifër të Uniref nuk është gjetur!'
            });
        }
    };

    async function handleSearch() {
        reCaptchaRef.current.reset();
        try {
            setKerkoLoading(true);
            const token = await reCaptchaRef.current.executeAsync();
            fetchInstitucioniServiceData(token);
        } catch (error) {
            setKerkoLoading(true);
        }
    };

    const handleBack = () => {
        navigate('/');
    }

    const payment_validationSchema = Yup.object().shape({
        numriIdentifikues: Yup.string().required('Numri personal është obligative!'),
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
    });

    const formik = useFormik({
        initialValues: {
            numriIdentifikues: '',
            Email: '',
        },
        validationSchema: payment_validationSchema,
        onSubmit: (values) => {
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(values);
        },
    });

    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                emri: InstitucioniServiceData.firstName,
                mbiemri: InstitucioniServiceData.lastName,
                institucioniId: 18,
                provizioni: provizioni && provizioni.provizioni,
                viti: `${new Date().getFullYear()}`,
                strProvizioni: `${provizioni && provizioni.provizioni}`,
                llojiPagesesID: 137,
                numriSerik: NumriSerik,
                paguesiAdresa: InstitucioniServiceData.municipality,
                numriUnikPageses: InstitucioniServiceData.uniref,
                numriIdentifikues: data.numriIdentifikues !== '' ? `${data.numriIdentifikues}` : '',
                strDataPageses: `${strDataPageses}`,
                shuma: provizioni && provizioni.strShuma,
                strVlera: `${provizioni && provizioni.strShuma}`,
                strVleraTotale: `${provizioni && provizioni.strtotal_pagesa}`,
                pershkrimi: 'Pagesë për Gjobat në Trafik',
                paymentMethod: 3,
                sherbimiTipiID: 7,
                unirefOK: false,
                token: token,
                PayWithLoan: Loan ? true : false
            }
            const response = await postData('Pagesat/PagesaPerSherbime', newData);
            if (response && response.status === 200) {
                if (!Loan) {
                    dispatch(setPaymentResponse(response.data.respond));
                    setPagesaLoading(false);
                } else {
                    setLoanLoading(false);
                    const paymentWindow = window.open('', '_self');
                    paymentWindow.location.href = `${response.data.link}`;
                }
            }
        } catch (error) {
            setLoanLoading(false);
            setPagesaLoading(false);
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    const handlePay = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    // provisioni

    const [provizioni, setProvizioni] = useState(null);

    const getProvizioni = async (data) => {
        try {
            const response = await getData(`Pagesat/GetProvision?LlojiPagesesID=15&Amount=${InstitucioniServiceData.valueToPay}`, data);
            if (response) {
                setProvizioni(response.data)
            }
        } catch (error) {
            // setInstitucioniList(null);
        }
    }

    useEffect(() => {
        if (InstitucioniServiceData && InstitucioniServiceData.valueToPay !== '') {
            getProvizioni();
        }
    }, [InstitucioniServiceData]);

    return (
        <div className="paysera-home paysera-feilds">
            <div className="home-header">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
            </div>
            <div className="paysera-form-body">
                <div className="form-box search-box">
                    <div className="form-body search-body">
                        <div className="paysera-form search-s">
                            <div className="paysera-inputLabel s-Label">
                                <label htmlFor="Numri Serik">Kërko përmes UNIREF <span className="required">*</span></label>
                                <div className="s-input">
                                    <OutlinedInput
                                        size="small"
                                        type="text"
                                        // autoFocus
                                        style={{ WebkitAppearance: 'textfield' }}
                                        id="outlined-adornment-input"
                                        placeholder="UNIREF"
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                            // autoComplete: 'off',
                                            // inputMode: 'text'
                                        }}
                                        onChange={(event) => setNumriSerik(event.target.value)}
                                        onKeyPress={(event) => {
                                            if (event.key === 'Enter' && NumriSerik !== undefined) {
                                                handleSearch();
                                            }
                                        }}
                                    />
                                    <Button
                                        type="button"
                                        className="dynamic-button"
                                        variant="contained"
                                        onClick={handleSearch}
                                        disabled={kerkoLoading || NumriSerik === undefined || NumriSerik === ''}
                                    >
                                        {kerkoLoading ? <CircularProgress size={24} /> : 'Kërko'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-box">
                    <Divider className='subheading-font' textAlign="center">Detajet e gjobës</Divider>
                    <div className="form-body">
                        {InstitucioniServiceData ? (
                            <div className="paysera-form">
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Emri</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Emri"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.firstName}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Mbiemri</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Mbiemri"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.lastName}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="numriIdentifikues" >Nr. Personal<span className="required"> *</span></label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Nr. Personal"
                                            type='number'
                                            className='number-input'
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                                inputMode: 'numeric'
                                            }}
                                            name='numriIdentifikues'
                                            value={formik.values.numriIdentifikues}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {
                                            formik.touched.numriIdentifikues && formik.errors.numriIdentifikues && (
                                                <FormHelperText>{formik.errors.numriIdentifikues}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Shëno email-in tuaj"
                                            name='Email'
                                            type="email"
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            value={formik.values.Email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.Email && formik.errors.Email}
                                        />
                                        {
                                            (formik.touched.Email && formik.errors.Email) &&
                                            (
                                                <FormHelperText>{formik.errors.Email}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Komuna</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Komuna"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData.municipality}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Data e gjobës</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Data e gjobës"
                                        type="text"
                                        disabled
                                        value={dayjs(InstitucioniServiceData.incidentDate).format('DD/MM/YYYY')}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Shuma e gjobës</label>
                                    <OutlinedInput
                                        disabled
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Shuma e gjobës"
                                        value={`${InstitucioniServiceData.fine} €`}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Shuma për pagesë</label>
                                    <OutlinedInput
                                        disabled
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Shuma për pagesë"
                                        aria-describedby="outlined-input-helper-text"
                                        value={`${InstitucioniServiceData.valueToPay} €`}
                                        endAdornment={<FaEuroSign />}
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Provizioni"> Provizioni</label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Provizioni"

                                            readOnly
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='Provizioni'
                                            value={provizioni && provizioni.provizioni}
                                        />
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Provizioni">Shuma Totale</label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Provizioni"
                                            endAdornment={<FaEuroSign />}
                                            readOnly
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='strVleraTotale'
                                            value={provizioni && provizioni.strtotal_pagesa}
                                        />
                                    </div>
                                </div>
                                <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                        <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePayWithLoan}
                                            // disabled
                                            // disabled={isLoading}
                                            startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                        </Button>
                                        <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePay}
                                            disabled={pagesaLoading}
                                            startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <div className="skeletonBox-detajet">
                                    <h4 className="skeleton-title-font" >Për të shfaqur detajet e pagesës së gjobës kërkoni përmes UNIREF.</h4>
                                </div>
                                <div className="skeleton-btn">
                                    <Button type="button" variant="outlined" onClick={handleBack}>
                                        Kthehu
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>

                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div>
    )
}

export default Policia_PaymentFields